import { useSphereDialog } from "@components/common/dialog/sphere-dialog-provider";
import { BaseProjectProps } from "@custom-types/project-types";
import { useAppDispatch } from "@store/store-helper";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { showArchiveProjectDialog } from "@utils/project-archive-utils";
import { useCallback } from "react";

/** Type of the callback returned by the custom hook */
type ProjectArchiveDialogFn = () => Promise<boolean>;

/**
 * Custom hook that returns a function to archive or unarchive a project.
 */
export function useProjectArchiveDialog({
  project,
}: BaseProjectProps): ProjectArchiveDialogFn {
  const { createDialog } = useSphereDialog();
  const dispatch = useAppDispatch();
  const { trackEvent } = useTrackEvent();

  const handleDialog = useCallback(async () => {
    return showArchiveProjectDialog({
      project,
      createDialog,
      dispatch,
      trackEvent,
    });
  }, [createDialog, dispatch, project, trackEvent]);

  return handleDialog;
}
